import firebase from 'firebase/app';
import 'firebase/messaging';

export const isBrowserSupported = firebase.messaging.isSupported();
let app = null
let messaging = null
// let messaging = null
// Initialize Firebase

if (isBrowserSupported)
  app = firebase.initializeApp({
    apiKey: "AIzaSyDqlGaL3kdABnavrG8s9ODibh6lQvCybyI",
    authDomain: "enquiry-bot-prod.firebaseapp.com",
    projectId: "enquiry-bot-prod",
    storageBucket: "enquiry-bot-prod.appspot.com",
    messagingSenderId: "608021433772",
    appId: "1:608021433772:web:6d614eb23a8d8b2a763e09"
  });

if (isBrowserSupported)
  messaging = firebase.messaging(app);

export const onMessageListener = () =>
  new Promise((resolve, reject) => {
    if (messaging) {
      messaging.onMessage((payload) => {
        resolve(payload);
      });
    } else {
      reject('fail');
    }
  });

export {
  messaging
}
